import React from "react";
import Helmet from "../components/Helmet/Helmet";
import CommonSection from "../components/UI/CommonSection";
import { Container, Row, Col } from "reactstrap";
import FindTransfer from "../components/UI/FindTransfer";

const Transfers = () => {
  return (
    <Helmet title="Home">
      <CommonSection title="Airport & Hotel Transfers" />
      <section className="p-0 hero__slider-section2">
        <div className="hero__form2">
          <Container>
            <Row className="form__row">
              <Col lg="4" md="4">
                <div className="find__cars-left">
                  <h2>Book your transfer now</h2>
                </div>
              </Col>

              <Col lg="8" md="8" sm="12">
                <FindTransfer />
              </Col>
            </Row>
          </Container>
        </div>
      </section>
    </Helmet>
  );
};

export default Transfers;
